import { render, staticRenderFns } from "./challengeModal.vue?vue&type=template&id=6a1b49c4&scoped=true&"
import script from "./challengeModal.vue?vue&type=script&lang=ts&"
export * from "./challengeModal.vue?vue&type=script&lang=ts&"
import style0 from "./challengeModal.vue?vue&type=style&index=0&id=6a1b49c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b49c4",
  null
  
)

export default component.exports